// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1thZb","legacyBtn":"MutateMid_legacyBtn__3bFUu"};